<div class="app-body kobeac-register">
    <main class="main">
        <div class="container py-4">
            <div class="row">
                <div class="col-lg-8 offset-lg-2">
                    <div class="card">
                        <div class="card-body">
                            <div class="text-center mb-3"><div class="logo"></div></div>
                            <h4 class="text-center mb-3">{{ 'register.title' | transloco }}</h4>

                            <div *ngIf="sent" class="alert alert-success">
                                <strong>{{ 'register.sent_title' | transloco }}</strong><br>
                                {{ 'register.sent_message' | transloco }}
                            </div>

                            <ng-container *ngIf="!sent">
                                <p class="text-muted">{{ 'register.intro' | transloco }}</p>

                                <div class="form-group">
                                    <label for="reg-company">{{ 'register.company_name' | transloco }}</label>
                                    <input id="reg-company" type="text" class="form-control" maxlength="100" autocomplete="organization" [(ngModel)]="form.companyName">
                                </div>
                                <div class="form-group">
                                    <label for="reg-trade">{{ 'register.trade_name' | transloco }}</label>
                                    <input id="reg-trade" type="text" class="form-control" maxlength="100" [(ngModel)]="form.tradeName">
                                    <small class="form-text text-muted">{{ 'register.name_hint' | transloco }}</small>
                                </div>
                                <div class="form-group">
                                    <label for="reg-antique">{{ 'register.antique_license_no' | transloco }}</label>
                                    <input id="reg-antique" type="text" class="form-control" maxlength="100" [(ngModel)]="form.antiqueLicenseNo"
                                           [placeholder]="'register.antique_license_placeholder' | transloco">
                                </div>
                                <div class="form-group">
                                    <label for="reg-invoice">{{ 'register.invoice_no' | transloco }}</label>
                                    <input id="reg-invoice" type="text" class="form-control" maxlength="20" [(ngModel)]="form.invoiceNo"
                                           [class.is-invalid]="!invoiceValid" placeholder="T1234567890123">
                                    <div class="invalid-feedback">{{ 'register.invoice_invalid' | transloco }}</div>
                                </div>
                                <div class="form-group">
                                    <label for="reg-rep">{{ 'register.representative' | transloco }} <span class="text-danger">*</span></label>
                                    <input id="reg-rep" type="text" class="form-control" maxlength="100" autocomplete="name" [(ngModel)]="form.representative">
                                </div>
                                <div class="form-group">
                                    <label for="reg-email">{{ 'register.email' | transloco }} <span class="text-danger">*</span></label>
                                    <input id="reg-email" type="email" class="form-control" maxlength="254" autocomplete="email" [(ngModel)]="form.email"
                                           [class.is-invalid]="form.email && !emailValid">
                                    <div class="invalid-feedback">{{ 'register.email_invalid' | transloco }}</div>
                                    <small class="form-text text-muted">{{ 'register.email_hint' | transloco }}</small>
                                </div>

                                <div class="form-group">
                                    <label>{{ 'register.privacy_policy' | transloco }}</label>
                                    <div class="register-policy border rounded p-2">{{ policy }}</div>
                                </div>
                                <div class="form-check mb-3">
                                    <input id="reg-accept" type="checkbox" class="form-check-input" [disabled]="!policy" [(ngModel)]="policyAccepted">
                                    <label for="reg-accept" class="form-check-label">{{ 'register.accept_policy' | transloco }}</label>
                                </div>

                                <div *ngIf="error" class="alert alert-danger">{{ error }}</div>
                                <button type="button" class="btn btn-primary btn-block" [disabled]="!canSubmit" (click)="submit()">
                                    {{ (sending ? 'register.sending' : 'register.submit') | transloco }}
                                </button>
                                <small class="form-text text-muted mt-2">{{ 'register.required_hint' | transloco }}</small>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</div>
